import { useEffect } from 'react';
import { Space } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import useBreadcrumb from 'hooks/useBreadcrumb';
import { DeclarationCountry } from 'store/declarations/enums/common/declaration-country';
import { DeclarationInternalType } from 'store/declarations/enums/common/declaration-internal-type';
import Button from 'components/new-ui/base/button/Button';
import PageHeader from 'components/new-ui/base/page-header/PageHeader';
import { StyledPageWrapper } from 'components/new-ui/base/wrappers/styles';
import { getDeclarationCountryFlag } from '../custom-declaration/utils';
import ArrivalNotificationsFilters from './ArrivalNotificationsFilters';
import ArrivalNotificationsTable from './ArrivalNotificationsTable';
import { arrivalDashboardBreadcrumbs } from './arrivalBreadcrumbs';
import useArrivalNotificationsList from './useArrivalNotificationsList';

const ArrivalNotificationsDashboard = () => {
    const navigate = useNavigate();
    const { setBreadcrumbRoutes } = useBreadcrumb();

    const {
        arrivals,
        isLoading,
        pageSize,
        mrnSearch,
        onMrnSearch,
        filters,
        applyFilter,
        removeFilter,
        clearFilters,
        onTableChange,
    } = useArrivalNotificationsList();

    useEffect(() => {
        setBreadcrumbRoutes(arrivalDashboardBreadcrumbs);
    }, [setBreadcrumbRoutes]);

    return (
        <StyledPageWrapper>
            <Space style={{ width: '100%' }} direction="vertical" size={24}>
                <PageHeader
                    icon={getDeclarationCountryFlag(DeclarationCountry.EU)}
                    title="Arrival Notifications (ICS2)"
                    sidebar={
                        <Button
                            type="primary"
                            icon={<PlusOutlined />}
                            onClick={() =>
                                navigate(
                                    `/invoice-upload/${DeclarationCountry.EU}/${DeclarationInternalType.ARRIVAL_NOTIFICATION_ICS2}`
                                )
                            }
                        >
                            Create Arrival Notification
                        </Button>
                    }
                />

                <ArrivalNotificationsFilters
                    mrnSearch={mrnSearch}
                    filters={filters}
                    onMrnSearch={onMrnSearch}
                    onApply={applyFilter}
                    onRemove={removeFilter}
                    onClearAll={clearFilters}
                />

                <ArrivalNotificationsTable
                    dataSource={arrivals?.list ?? []}
                    loading={isLoading}
                    onChange={onTableChange}
                    pagination={{
                        current: (arrivals?.pageNumber ?? 0) + 1,
                        pageSize: arrivals?.pageSize ?? pageSize,
                        total: arrivals?.total,
                        hideOnSinglePage: true,
                        showSizeChanger: true,
                    }}
                />
            </Space>
        </StyledPageWrapper>
    );
};

export default ArrivalNotificationsDashboard;
